import { bigInt, bulkMemory, exceptions, multiValue, mutableGlobals, referenceTypes, saturatedFloatToInt, streamingCompilation, threads } from "wasm-feature-detect";

/**
WASM - kanal
bigInt()
bulkMemory()
exceptions()
multiValue()
mutableGlobals()
referenceTypes()
saturatedFloatToInt()
streamingCompilation() - tohle je asi fajn browser umi kompilovat wasm v prubeho jeho stahovani, ale neni to uplne nutne mit to
threads()
*/

export async function isWasmEnabled() {
	const [bigIntVal, bulkMemoryVal, exceptionsVal, multiValueVal, mutableGlobalsVal, referenceTypesVal, saturatedFloatToIntVal, streamingCompilationVal, threadsVal] = await Promise.all([
		bigInt(),
		bulkMemory(),
		exceptions(),
		multiValue(),
		mutableGlobals(),
		referenceTypes(),
		saturatedFloatToInt(),
		streamingCompilation(),
		threads(),
	]);

	return bigIntVal && bulkMemoryVal && exceptionsVal && multiValueVal && mutableGlobalsVal && referenceTypesVal && saturatedFloatToIntVal && streamingCompilationVal && threadsVal;
}
